export const paisesParaAutocomplete = [
  { label: 'Afganistán', value: 'af' },
  { label: 'Albania', value: 'al' },
  { label: 'Alemania', value: 'de' },
  { label: 'Andorra', value: 'ad' },
  { label: 'Angola', value: 'ao' },
  { label: 'Antigua y Barbuda', value: 'ag' },
  { label: 'Arabia Saudita', value: 'sa' },
  { label: 'Argelia', value: 'dz' },
  { label: 'Argentina', value: 'ar' },
  { label: 'Armenia', value: 'am' },
  { label: 'Australia', value: 'au' },
  { label: 'Austria', value: 'at' },
  { label: 'Azerbaiyán', value: 'az' },
  { label: 'Bahamas', value: 'bs' },
  { label: 'Bangladés', value: 'bd' },
  { label: 'Barbados', value: 'bb' },
  { label: 'Baréin', value: 'bh' },
  { label: 'Bélgica', value: 'be' },
  { label: 'Belice', value: 'bz' },
  { label: 'Benín', value: 'bj' },
  { label: 'Bielorrusia', value: 'by' },
  { label: 'Bolivia', value: 'bo' },
  { label: 'Bosnia y Herzegovina', value: 'ba' },
  { label: 'Botsuana', value: 'bw' },
  { label: 'Brasil', value: 'br' },
  { label: 'Brunéi', value: 'bn' },
  { label: 'Bulgaria', value: 'bg' },
  { label: 'Burkina Faso', value: 'bf' },
  { label: 'Burundi', value: 'bi' },
  { label: 'Bután', value: 'bt' },
  { label: 'Cabo Verde', value: 'cv' },
  { label: 'Camboya', value: 'kh' },
  { label: 'Camerún', value: 'cm' },
  { label: 'Canadá', value: 'ca' },
  { label: 'Catar', value: 'qa' },
  { label: 'Chad', value: 'td' },
  { label: 'Chile', value: 'cl' },
  { label: 'China', value: 'cn' },
  { label: 'Chipre', value: 'cy' },
  { label: 'Colombia', value: 'co' },
  { label: 'Comoras', value: 'km' },
  { label: 'Corea del Norte', value: 'kp' },
  { label: 'Corea del Sur', value: 'kr' },
  { label: 'Costa de Marfil', value: 'ci' },
  { label: 'Costa Rica', value: 'cr' },
  { label: 'Croacia', value: 'hr' },
  { label: 'Cuba', value: 'cu' },
  { label: 'Dinamarca', value: 'dk' },
  { label: 'Dominica', value: 'dm' },
  { label: 'Ecuador', value: 'ec' },
  { label: 'Egipto', value: 'eg' },
  { label: 'El Salvador', value: 'sv' },
  { label: 'Emiratos Árabes Unidos', value: 'ae' },
  { label: 'Eritrea', value: 'er' },
  { label: 'Eslovaquia', value: 'sk' },
  { label: 'Eslovenia', value: 'si' },
  { label: 'España', value: 'es' },
  { label: 'Estados Unidos', value: 'us' },
  { label: 'Estonia', value: 'ee' },
  { label: 'Etiopía', value: 'et' },
  { label: 'Filipinas', value: 'ph' },
  { label: 'Finlandia', value: 'fi' },
  { label: 'Fiyi', value: 'fj' },
  { label: 'Francia', value: 'fr' },
  { label: 'Gabón', value: 'ga' },
  { label: 'Gambia', value: 'gm' },
  { label: 'Georgia', value: 'ge' },
  { label: 'Ghana', value: 'gh' },
  { label: 'Granada', value: 'gd' },
  { label: 'Grecia', value: 'gr' },
  { label: 'Guatemala', value: 'gt' },
  { label: 'Guinea', value: 'gn' },
  { label: 'Guinea-Bisáu', value: 'gw' },
  { label: 'Guinea Ecuatorial', value: 'gq' },
  { label: 'Guyana', value: 'gy' },
  { label: 'Haití', value: 'ht' },
  { label: 'Honduras', value: 'hn' },
  { label: 'Hungría', value: 'hu' },
  { label: 'India', value: 'in' },
  { label: 'Indonesia', value: 'id' },
  { label: 'Irak', value: 'iq' },
  { label: 'Irán', value: 'ir' },
  { label: 'Irlanda', value: 'ie' },
  { label: 'Islandia', value: 'is' },
  { label: 'Islas Marshall', value: 'mh' },
  { label: 'Islas Salomón', value: 'sb' },
  { label: 'Israel', value: 'il' },
  { label: 'Italia', value: 'it' },
  { label: 'Jamaica', value: 'jm' },
  { label: 'Japón', value: 'jp' },
  { label: 'Jordania', value: 'jo' },
  { label: 'Kazajistán', value: 'kz' },
  { label: 'Kenia', value: 'ke' },
  { label: 'Kirguistán', value: 'kg' },
  { label: 'Kiribati', value: 'ki' },
  { label: 'Kuwait', value: 'kw' },
  { label: 'Laos', value: 'la' },
  { label: 'Lesoto', value: 'ls' },
  { label: 'Letonia', value: 'lv' },
  { label: 'Líbano', value: 'lb' },
  { label: 'Liberia', value: 'lr' },
  { label: 'Libia', value: 'ly' },
  { label: 'Liechtenstein', value: 'li' },
  { label: 'Lituania', value: 'lt' },
  { label: 'Luxemburgo', value: 'lu' },
  { label: 'Macedonia del Norte', value: 'mk' },
  { label: 'Madagascar', value: 'mg' },
  { label: 'Malasia', value: 'my' },
  { label: 'Malaui', value: 'mw' },
  { label: 'Maldivas', value: 'mv' },
  { label: 'Malí', value: 'ml' },
  { label: 'Malta', value: 'mt' },
  { label: 'Marruecos', value: 'ma' },
  { label: 'Mauricio', value: 'mu' },
  { label: 'Mauritania', value: 'mr' },
  { label: 'México', value: 'mx' },
  { label: 'Micronesia', value: 'fm' },
  { label: 'Moldavia', value: 'md' },
  { label: 'Mónaco', value: 'mc' },
  { label: 'Mongolia', value: 'mn' },
  { label: 'Montenegro', value: 'me' },
  { label: 'Mozambique', value: 'mz' },
  { label: 'Birmania', value: 'mm' },
  { label: 'Namibia', value: 'na' },
  { label: 'Nauru', value: 'nr' },
  { label: 'Nepal', value: 'np' },
  { label: 'Nicaragua', value: 'ni' },
  { label: 'Níger', value: 'ne' },
  { label: 'Nigeria', value: 'ng' },
  { label: 'Noruega', value: 'no' },
  { label: 'Nueva Zelanda', value: 'nz' },
  { label: 'Omán', value: 'om' },
  { label: 'Países Bajos', value: 'nl' },
  { label: 'Pakistán', value: 'pk' },
  { label: 'Palaos', value: 'pw' },
  { label: 'Panamá', value: 'pa' },
  { label: 'Papúa Nueva Guinea', value: 'pg' },
  { label: 'Paraguay', value: 'py' },
  { label: 'Perú', value: 'pe' },
  { label: 'Polonia', value: 'pl' },
  { label: 'Portugal', value: 'pt' },
  { label: 'Reino Unido', value: 'gb' },
  { label: 'República Centroafricana', value: 'cf' },
  { label: 'República Checa', value: 'cz' },
  { label: 'República del Congo', value: 'cg' },
  { label: 'República Democrática del Congo', value: 'cd' },
  { label: 'República Dominicana', value: 'do' },
  { label: 'Ruanda', value: 'rw' },
  { label: 'Rumania', value: 'ro' },
  { label: 'Rusia', value: 'ru' },
  { label: 'Samoa', value: 'ws' },
  { label: 'San Cristóbal y Nieves', value: 'kn' },
  { label: 'San Marino', value: 'sm' },
  { label: 'San Vicente y las Granadinas', value: 'vc' },
  { label: 'Santa Lucía', value: 'lc' },
  { label: 'Santo Tomé y Príncipe', value: 'st' },
  { label: 'Senegal', value: 'sn' },
  { label: 'Serbia', value: 'rs' },
  { label: 'Seychelles', value: 'sc' },
  { label: 'Sierra Leona', value: 'sl' },
  { label: 'Singapur', value: 'sg' },
  { label: 'Siria', value: 'sy' },
  { label: 'Somalia', value: 'so' },
  { label: 'Sri Lanka', value: 'lk' },
  { label: 'Suazilandia', value: 'sz' },
  { label: 'Sudáfrica', value: 'za' },
  { label: 'Sudán', value: 'sd' },
  { label: 'Sudán del Sur', value: 'ss' },
  { label: 'Suecia', value: 'se' },
  { label: 'Suiza', value: 'ch' },
  { label: 'Surinam', value: 'sr' },
  { label: 'Tailandia', value: 'th' },
  { label: 'Tanzania', value: 'tz' },
  { label: 'Tayikistán', value: 'tj' },
  { label: 'Timor Oriental', value: 'tl' },
  { label: 'Togo', value: 'tg' },
  { label: 'Tonga', value: 'to' },
  { label: 'Trinidad y Tobago', value: 'tt' },
  { label: 'Túnez', value: 'tn' },
  { label: 'Turkmenistán', value: 'tm' },
  { label: 'Turquía', value: 'tr' },
  { label: 'Tuvalu', value: 'tv' },
  { label: 'Ucrania', value: 'ua' },
  { label: 'Uganda', value: 'ug' },
  { label: 'Uruguay', value: 'uy' },
  { label: 'Uzbekistán', value: 'uz' },
  { label: 'Vanuatu', value: 'vu' },
  { label: 'Venezuela', value: 've' },
  { label: 'Vietnam', value: 'vn' },
  { label: 'Yemen', value: 'ye' },
  { label: 'Yibuti', value: 'dj' },
  { label: 'Zambia', value: 'zm' },
  { label: 'Zimbabue', value: 'zw' },
];
